// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'

import VueRouter from 'vue-router'
import ToggleButton from 'vue-js-toggle-button'
import VeeValidate from 'vee-validate';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import { routes, publicRoutes, superAdminRoute, clientAdminRoute, userRoute, employerAdminRoute, employerRoute } from './routes.js'
import VueProgressBar from 'vue-progressbar'
import infiniteScroll from 'vue-infinite-scroll'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'

import i18n from './lang/i18n.js'

import "./utils/translater.js";


import * as VueGoogleMaps from 'vue2-google-maps';


Vue.prototype.$language = localStorage.getItem('lang') || 'en';

// vue croper
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

import { Drag, Drop } from 'vue-drag-drop';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';       // Font Awesome CSS
import 'bootstrap/dist/js/bootstrap.min.js';          // Bootstrap JS
import 'jquery';                                      // jQuery
// Import vue-bootstrap-datetimepicker styles
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css';
// Register vue-bootstrap-datetimepicker globally
import datePicker from 'vue-bootstrap-datetimepicker';
// Use jQuery globally (necessary for Bootstrap and the datetime picker to work)
window.$ = window.jQuery = require('jquery');
// Register and use the datetime picker
//import 'bootstrap/dist/css/bootstrap.css';
// import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
import FullCalendar from 'vue-full-calendar'
import vueScrollto from 'vue-scrollto'
import store from './store/store.js'
import InfiniteScroll from 'v-infinite-scroll';
import VueKeepScrollPosition from 'vue-keep-scroll-position'
import 'v-infinite-scroll/dist/v-infinite-scroll.css';
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import en from 'vee-validate/dist/locale/en';
import es from 'vee-validate/dist/locale/es';
import fr from 'vee-validate/dist/locale/fr';
import VueAppleLogin from 'vue-apple-login';

export const bus = new Vue();

Vue.config.productionTip = false;

Vue.use(datePicker);
$.extend(true, $.fn.datetimepicker.defaults, {
    icons: {
        time: 'fa fa-clock-o',
        date: 'fa fa-calendar',
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-check',
        clear: 'fa fa-trash',
        close: 'fa fa-times'
    }
});
Vue.use(VueKeepScrollPosition);
Vue.use(InfiniteScroll);
Vue.use(VueRouter);
Vue.use(i18n);
Vue.use(ToggleButton);
Vue.use(VeeValidate, {
    i18nRootKey: 'validations',
    i18n,
    dictionary: {
        en: {
            custom: {
                StartAddDate: {
                    required: 'Start Date field is empty'
                },
                StartEditDate: {
                    required: 'Start Date field is empty'
                },
                Event: {
                    required: 'Event name field is empty'
                },
                resetemail: {
                    required: 'Your email field is empty'
                },
                StartAddDate: {
                    required: 'Start field is empty'
                },
                end: {
                    required: 'End Date field is empty'
                },
                employerName: {
                    required: 'Employer name field is empty'
                },
                streetAddress: {
                    required: 'Address field is empty'
                },
                priphone: {
                    required: 'Phone number is empty'
                },
                userName: {
                    required: 'User name is required'
                },
                cnfPassword: {
                    required: 'Confirm password is required'
                },
                firstName: {
                    required: 'First name is required'
                },
                lastName: {
                    required: 'Last name is required'
                },
                streetAdd: {
                    required: 'Address field is empty'
                },
                cellPhone: {
                    required: 'Phone number must have minimum length 10',
                    digits: 'Phone number must have minimum length 10',
                },
                homePhone: {
                    required: 'Phone number must have minimum length 10',
                    digits: 'Phone number must have minimum length 10',
                },
                state_province: {
                    required: 'State/Province is empty'
                },
                postcode: {
                    required: 'Postal code is empty'
                },
                sendid: {
                    required: 'Send address is required'
                },
                startDate: {
                    required: 'Start Date is required'
                },
                endDate: {
                    required: 'End Date is required'
                },
                startTime: {
                    required: 'Start Time is required'
                },
                endTime: {
                    required: 'End Time is required'
                },
                createdBy: {
                    required: 'Please check your skills definitions of steward & dispatched by'
                },
                steward: {
                    required: 'Please check your skills definitions of steward & dispatched by'
                }

            }
        },
        es: {
            custom: {
                StartAddDate: {
                    required: 'El campo Fecha de inicio está vacío'
                },
                StartEditDate: {
                    required: 'El campo Fecha de inicio está vacío'
                },
                Event: {
                    required: 'El campo Nombre del evento está vacío'
                },
                resetemail: {
                    required: 'El campo de correo electrónico está vacío'
                },
                StartAddDate: {
                    required: 'El campo Inicio está vacío'
                },
                end: {
                    required: 'El campo Fecha de finalización está vacío'
                },
                employerName: {
                    required: 'El campo Nombre del empleador está vacío'
                },
                streetAddress: {
                    required: 'El campo de dirección está vacío'
                },
                priphone: {
                    required: 'El número de teléfono está vacío'
                },
                userName: {
                    required: 'Se requiere nombre de usuario'
                },
                cnfPassword: {
                    required: 'Se requiere confirmar contraseña'
                },
                firstName: {
                    required: 'Se requiere nombre'
                },
                lastName: {
                    required: 'Se requiere apellido'
                },
                streetAdd: {
                    required: 'El campo de dirección está vacío'
                },
                cellPhone: {
                    required: 'El número de teléfono debe tener una longitud mínima 10',
                    digits: 'El número de teléfono debe tener una longitud mínima 10',
                },
                homePhone: {
                    required: 'El número de teléfono debe tener una longitud mínima 10',
                    digits: 'El número de teléfono debe tener una longitud mínima 10',
                },
                state_province: {
                    required: 'Estado/Provincia está vacío'
                },
                postcode: {
                    required: 'El código postal está vacío'
                },
                sendid: {
                    required: 'Se requiere dirección de envío'
                },
                startDate: {
                    required: 'Se requiere fecha de inicio'
                },
                endDate: {
                    required: 'Se requiere fecha de finalización'
                },
                startTime: {
                    required: 'Se requiere hora de inicio'
                },
                endTime: {
                    required: 'Se requiere hora de finalización'
                },
                createdBy: {
                    required: 'Por favor, compruebe sus definiciones de habilidades de mayordomo y enviado por'
                },
                steward: {
                    required: 'Por favor, compruebe sus definiciones de habilidades de mayordomo y enviado por'
                }

            }
        },
        fr: {
            custom: {
                StartAddDate: {
                    required: 'Le champ Démarrer est vide'
                },
                StartEditDate: {
                    required: 'Le champ Démarrer est vide'
                },
                Event: {
                    required: 'Le champ Nom de l’événement est vide'
                },
                resetemail: {
                    required: 'Votre champ d’e-mail est vide'
                },
                StartAddDate: {
                    required: 'Le champ Démarrer est vide'
                },
                end: {
                    required: 'Le champ Date de fin est vide'
                },
                employerName: {
                    required: 'Le champ Nom de l’employeur est vide'
                },
                streetAddress: {
                    required: 'Le champ Adresse est vide'
                },
                priphone: {
                    required: 'Le numéro de téléphone est vide'
                },
                userName: {
                    required: 'Le nom d’utilisateur est requis'
                },
                cnfPassword: {
                    required: 'Confirmer que le mot de passe est requis'
                },
                firstName: {
                    required: 'Prénom requis'
                },
                lastName: {
                    required: 'Le nom de famille est requis'
                },
                streetAdd: {
                    required: 'Le champ Adresse est vide'
                },
                cellPhone: {
                    required: 'Le numéro de téléphone doit avoir une longueur minimale 10',
                    digits: 'Le numéro de téléphone doit avoir une longueur minimale 10',
                },
                homePhone: {
                    required: 'Le numéro de téléphone doit avoir une longueur minimale 10',
                    digits: 'Le numéro de téléphone doit avoir une longueur minimale 10',
                },
                state_province: {
                    required: 'L’État/la province est vide'
                },
                postcode: {
                    required: 'Le code postal est vide'
                },
                sendid: {
                    required: 'L’adresse d’envoi est requise'
                },
                startDate: {
                    required: 'La date de début est requise'
                },
                endDate: {
                    required: 'La date de fin est requise'
                },
                startTime: {
                    required: 'L’heure de début est requise'
                },
                endTime: {
                    required: 'L’heure de fin est requise'
                },
                createdBy: {
                    required: 'S’il vous plaît vérifier vos définitions de compétences de steward & dispatched par'
                },
                steward: {
                    required: 'S’il vous plaît vérifier vos définitions de compétences de steward & dispatched par'
                }

            }
        },
        en,
        es,
        fr
    }
});
Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(VueProgressBar, options);
Vue.use(infiniteScroll);
Vue.use(VModal);
Vue.use(VTooltip);
Vue.use(FullCalendar);
Vue.component('drag', Drag);
Vue.component('drop', Drop);
Vue.use(ElementUI, {
    locale
});
//vue croper
Vue.component(VueCropper);
Vue.use(vueScrollto);
// Google Map
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBngxxJ-H5reyDULmda4mWXJuyK1Hb6WTI',
    },
});

let redirectUrl = window.location.href.split('#')[0];
// let redirectUrl = 'https://dev-callsteward.com/'
// console.log("redirectUrl:" + redirectUrl);

Vue.use(VueAppleLogin, {
    clientId: 'com.callsteward.service-id',
    scope: 'name email',
    redirectURI: redirectUrl,
    usePopup: true,
    state: 'initial'
});

//console.log('test',store.getters.employeeId);
const router = new VueRouter({
    // base: (process.env.NODE_ENV == "development") ? '/login' : '/web/',
    base: (process.env.NODE_ENV == "development") ? '/' : '/',
    routes,
});
let count = 0;
const options = {
    color: '#bffaf3',
    failedColor: '#874b4b',
    thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'left',
    inverse: false
};

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function deviceDetector() {
    let userAgent = navigator.userAgent.toLowerCase();
    const check = (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");

    return ("desktop" != check ? !0 : !1);
}
function setCookie(name, value, days) {
    console.log("Check");
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}  

router.beforeEach((to, from, next) => {
    const isMobile = deviceDetector();
    // console.log('deviceDetector',isMobile);
    if (isMobile) {
        viewport.setAttribute('content', 'width=1024');
    } else {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1, user-scalable=no');
    }

    if (to.name == 'magicLink' && (getCookie('csLogin') != "" || getCookie('csLogin') != null)) {
        // this.$cookies.remove("csLogin", "/mobile");
        // this.$cookies.remove("csLogin");
        // this.$cookies.remove("date_format");
        // this.$cookies.remove("time_format");
        // this.$cookies.remove("time_zone");
        // localStorage.removeItem('vuex');
        // this.$store.dispatch('setTokenExpiry', '');
        setCookie('csLogin', "", 1);
        localStorage.clear();
    }
    if (getCookie('csLogin') !== "" && getCookie('csLogin') !== null) {
        let ch = getCookie('csLogin');
        switch (ch) {
            case 'super-admin':
                if (superAdminRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/clientList');
                }
                break;

            case 'client-admin':
                if (clientAdminRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/jobList');
                }
                break;

            case 'power-user':
                if (clientAdminRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/jobList');
                }
                break;

            case "auditor":
                if (clientAdminRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/jobList');
                }
                break;

            case 'employee':
                console.log(from.name);
                if (userRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    console.log("Check 1");
                    if(count == 1) {
                        Vue.prototype.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                    }
                    if (from.name == 'actionLog') {
                        count += 1;
                    }
                    next('/schedule/' + btoa(store.getters.loggedInEmployeeId));
                }
                break;

            case 'employer-admin':
                if (employerAdminRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/employerJobList');
                }
                break;

            case 'employer':
                // console.log('employer', to.name);
                if (employerRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/employerJobList');
                }
                break;
            default:
                // console.log('default', ch)
                next('/pageNotFound');
        }
    } else if (publicRoutes.indexOf(to.name) != -1) {
        next();
    } else {
        next("/login");
    }

    // if (to.path == "/") {
    //     if (getCookie('csLogin') !== "") {

    //         switch(getCookie('csLogin')){
    //             case 'super-admin':
    //                 next('/clientList');
    //                 break;

    //             case 'client-admin':
    //                 next('/jobList');
    //                 break;

    //             case 'power-user':
    //                 next('/jobList');
    //                 break;

    //             case 'employee':
    //                 next('/schedule/'+btoa(store.getters.employeeId));
    //                 break;

    //             case 'employer-admin':
    //                 next('/employerJobList');
    //                 break;
    //             case 'employer':
    //                 next('/employerJobList');
    //                 break;

    //             default:
    //                 next('/pageNotFound');
    //         }

    //     } else {
    //         if (to.name == "resetPassword" || to.name == "pageNotFound") {
    //             next();
    //         } else {
    //             next("/login");
    //         }
    //     }
    // } else {
    //     if (to.path != '/login') {
    //         if (getCookie('csLogin') !== ""){

    //             switch(getCookie('csLogin')){

    //                 case 'super-admin':
    //                     if(superAdminRoute.indexOf(to.name)!=-1)
    //                         next();
    //                     else
    //                         next('/clientList');
    //                     break;

    //                 case 'client-admin':
    //                     if(clientAdminRoute.indexOf(to.name)!=-1)
    //                         next();
    //                     else
    //                         next('/jobList');
    //                     break;

    //                 case 'power-user':
    //                     if(clientAdminRoute.indexOf(to.name)!=-1)
    //                         next();
    //                     else
    //                         next('/jobList');
    //                     break;

    //                 case 'employee':
    //                     if(userRoute.indexOf(to.name)!=-1)
    //                         next();
    //                     else
    //                         next('/schedule/'+btoa(store.getters.employeeId));
    //                     break;

    //                 case 'employer-admin':
    //                     if(employerAdminRoute.indexOf(to.name)!=-1)
    //                         next();
    //                     else
    //                         next('/employerJobList');
    //                     break;
    //                 case 'employer':
    //                     if(employerRoute.indexOf(to.name)!=-1)
    //                         next();
    //                     else
    //                         next('/employerJobList');
    //                     break;

    //                 default:
    //                     next('/pageNotFound');
    //             }
    //             // console.log(to.name, clientAdminRoute.indexOf(to.name));
    //             // if (getCookie('csLogin') != 'super-admin') {
    //             //     if (getCookie('csLogin') == 'client-admin' || getCookie('csLogin') == 'power-user') {
    //             //         if(clientAdminRoute.indexOf(to.name)!=-1)
    //             //             next();
    //             //         else
    //             //             next('/jobList');
    //             //     }else{
    //             //         if(userRoute.indexOf(to.name)!=-1)
    //             //             next();
    //             //         else
    //             //             next('/schedule/'+btoa(store.getters.employeeId));
    //             //     }
    //             // }else{
    //             //     if(superAdminRoute.indexOf(to.name)!=-1)
    //             //         next();
    //             //     else
    //             //         next('/clientList')
    //             // }
    //         }else {
    //             if (to.name == "resetPassword" || to.name == "pageNotFound" || to.name=='forceLogin') {
    //                 next();
    //             } else {
    //                 next("/login");
    //             }
    //         }
    //     } else {
    //         if (getCookie('csLogin') !== "") {
    //             switch(getCookie('csLogin')){
    //                 case 'super-admin':
    //                     next('/clientList');
    //                     break;

    //                 case 'client-admin':
    //                     next('/jobList');
    //                     break;

    //                 case 'power-user':
    //                     next('/jobList');
    //                     break;

    //                 case 'employee':
    //                     next('/schedule/'+btoa(store.getters.employeeId));
    //                     break;

    //                 case 'employer-admin':
    //                     next('/employerJobList');
    //                     break;

    //                 case 'employer':
    //                     next('/employerJobList');
    //                     break;

    //                 default:
    //                     next('/pageNotFound');
    //             }
    //             // if (getCookie('csLogin') != 'super-admin') {

    //             //     if (getCookie('csLogin') == 'client-admin' || getCookie('csLogin') == 'power-user')
    //             //         next('/jobList');
    //             //     else
    //             //         next('/schedule/'+btoa(store.getters.employeeId));
    //             // } else {

    //             //     next('/clientList');
    //             // }
    //         } else{
    //             next();
    //         }
    //     }
    // }
});
new Vue({
    el: '#app',
    router,
    i18n,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js